import {
  dateOfBirthRegex,
  phoneRegex
} from '@/constants/regex';
import { useMemo } from 'react';

export const useGetRequiredRule = () => useMemo(() => ({
  required: true,
  message: 'Обов\'язкове поле',
}), []);


export const useGetPhoneRule = () =>
  useMemo(
    () => ({
      pattern: phoneRegex,
      message: "Введіть коректний номер телефону",
    }),
    [],
  );

export const useGetDateOfBirthRule = () =>
  useMemo(
    () => ({
      pattern: dateOfBirthRegex,
      message: "Введіть дату у форматі ДД.ММ.РРРР",
    }),
    [],
  );
